import { memo } from 'react';
import { Outlet } from 'react-router-dom';

import { InitSettings } from '@/entities/Settings/components/InitSettings.tsx';

import { DesktopLayout } from '@/shared/layouts/DesktopLayout';
import useAppStore from '@/shared/store/app.store';
import { useSettingsStore } from '@/shared/store/settings.store.ts';

// Лейаут раздела «Администрирование»: без левого блока, контент занимает всю ширину.
const AdminLayout = () => {
	const isMobile = useAppStore((state) => state.isMobile);
	const workTime = useSettingsStore((state) => state.workTime);
	const location = useSettingsStore((state) => state.location);

	if (!workTime || !location) return <InitSettings />;

	if (isMobile === null) return;

	return <DesktopLayout rightSlot={<Outlet />} />;
};

export default memo(AdminLayout);
